import { ModuleLink } from "components/common/moduleNavigation/moduleTypes/moduleTypes";
import chairIcon from "assets/images/moduleNavigationIcons/chair.svg";
import { Unloadings } from "routes/wms/Unloadings";

export const etiquettes: ModuleLink = {
  url: "etiquettes",
  label: "Etykiety",
  icon: chairIcon,
  subSection: <></>,
  routing: Unloadings,
  isAccessible: false,
};
